import api from './api';

const secretariaService = {
  listar: () => api.get('/secretarias'),
  criar: (dados) => api.post('/secretarias', dados),
  atualizar: (id, dados) => api.put(`/secretarias/${id}`, dados),
  remover: (id) => api.delete(`/secretarias/${id}`),
};

export default secretariaService;
